import { BaseWalletFactory, } from '@portkey/types';
export var GuardianType;
(function (GuardianType) {
    GuardianType[GuardianType["GUARDIAN_TYPE_OF_EMAIL"] = 0] = "GUARDIAN_TYPE_OF_EMAIL";
    GuardianType[GuardianType["GUARDIAN_TYPE_OF_PHONE"] = 1] = "GUARDIAN_TYPE_OF_PHONE";
    GuardianType[GuardianType["Email"] = 0] = "Email";
    GuardianType[GuardianType["Phone"] = 1] = "Phone";
})(GuardianType || (GuardianType = {}));
export class BaseDIDWallet extends BaseWalletFactory {
}
